exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cross[data-v-3f350767]{color:#000;position:absolute;right:20px;top:10px;font-size:16px;font-weight:700}.media-container[data-v-3f350767]{position:absolute;z-index:9;border:3px solid #d3d3d3;border-radius:.5em;width:9em}.copy-clipboard[data-v-3f350767],.subtitle[data-v-3f350767]{color:#000;vertical-align:top;text-align:center;font-weight:400;font-size:.4em}.btn-white[data-v-3f350767]{background-color:#fff;border:#fff;outline:none}.btn-white[data-v-3f350767]:hover,.copy-clipboard[data-v-3f350767]:hover{cursor:pointer}a[data-v-3f350767]:hover{text-decoration:none}", ""]);

// exports
